module.exports = __webpack_public_path__ + "img/logo-2-1-ratio.9043bb90.png";